import script from "./give.vue?vue&type=script&setup=true&name=give&lang=js"
export * from "./give.vue?vue&type=script&setup=true&name=give&lang=js"

import "./give.vue?vue&type=style&index=0&id=fea53fc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea53fc6"]])

export default __exports__